import { Styled } from './';

const LoadingSpinner = ({
  width,
  height,
}: {
  width?: string;
  height?: string;
}) => {
  return <Styled.SpinLoader width={width} height={height}></Styled.SpinLoader>;
};

export default LoadingSpinner;
